import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class GoalRevenuesApi extends CrudBase {

  getGoalRevenues = (date, params) => axios.get(`${this.endpoint}/get-by?date=${date}`, params);

  defaultMethods = {
    getGoalRevenues: this.getGoalRevenues,
  }
};

const acompanhamento = new GoalRevenuesApi('api/v1/goal-revenues');

export default acompanhamento.defaultMethods;
